// Model that represents an error. Components that are passed
// this as the model should render an error state.
export default class ErrorModel extends Backbone.Model {
  get defaults () {
    return {
      // error code. 404 | 500 | etc.
      code: 0,
      message: ''
    }
  }
}
